import { render, staticRenderFns } from "./ActoEventos.vue?vue&type=template&id=fa09e8cc&scoped=true"
import script from "./ActoEventos.vue?vue&type=script&lang=js"
export * from "./ActoEventos.vue?vue&type=script&lang=js"
import style0 from "./ActoEventos.vue?vue&type=style&index=0&id=fa09e8cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa09e8cc",
  null
  
)

export default component.exports